import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Grazie = () => {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const sessionId = params.get("session_id");
    const provider = params.get("provider");
    const cancelled = params.get("annullato");

    if (cancelled) {
      setState("cancelled");
      return;
    }
    if (provider === "paypal") {
      const token = params.get("token");
      if (!token) {
        setState("failed");
        return;
      }
      axios
        .post(`${API}/payments/paypal/${token}/capture`)
        .then(({ data }) => setState(data.payment_status === "paid" ? "paid" : "failed"))
        .catch(() => setState("failed"));
      return;
    }
    if (sessionId) {
      let attempts = 0;
      const poll = async () => {
        try {
          const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
          if (data.payment_status === "paid") {
            setState("paid");
            return;
          }
        } catch {
          // keep polling briefly
        }
        attempts += 1;
        if (attempts < 8) setTimeout(poll, 1500);
        else setState("failed");
      };
      poll();
      return;
    }
    setState("failed");
  }, [params]);

  return (
    <div data-testid="grazie-page" className="min-h-screen flex items-center justify-center px-6 pt-20">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#0D253A]/10 p-10 shadow-xl text-center">
        {state === "loading" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-[#C86D51] animate-spin" />
            <h1 className="font-display text-2xl text-[#0D253A] mt-6">Verifica del pagamento…</h1>
            <p className="text-sm text-[#5C6773] mt-2">Stiamo confermando il tuo pagamento, attendi un istante.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 data-testid="grazie-success-icon" className="w-12 h-12 mx-auto text-green-600" />
            <h1 className="font-display text-2xl text-[#0D253A] mt-6">Prenotazione confermata!</h1>
            <p className="text-sm text-[#5C6773] mt-2">
              Pagamento ricevuto. Il proprietario ti contatterà a breve con tutti i dettagli per il check-in. A presto a Isola delle Femmine!
            </p>
          </>
        )}
        {state === "cancelled" && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-amber-500" />
            <h1 className="font-display text-2xl text-[#0D253A] mt-6">Pagamento annullato</h1>
            <p className="text-sm text-[#5C6773] mt-2">Nessun addebito effettuato. Puoi riprovare dal link ricevuto via email.</p>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle data-testid="grazie-error-icon" className="w-12 h-12 mx-auto text-red-500" />
            <h1 className="font-display text-2xl text-[#0D253A] mt-6">Qualcosa è andato storto</h1>
            <p className="text-sm text-[#5C6773] mt-2">Non siamo riusciti a verificare il pagamento. Contattaci e risolveremo subito.</p>
          </>
        )}
        <Link
          data-testid="grazie-home-link"
          to="/"
          className="inline-block mt-8 px-8 py-3 bg-[#0D253A] text-[#F8F5F0] text-sm font-semibold rounded-full hover:bg-[#C86D51] transition-colors"
        >
          Torna alla home
        </Link>
      </div>
    </div>
  );
};

export default Grazie;
